import starImage from "../assets/star.png";

export class Star {
  x: number;
  y: number;
  width: number;
  height: number;
  image: HTMLImageElement;

  hitboxX: number;
  hitboxY: number;
  hitboxWidth: number;
  hitboxHeight: number;

  constructor(randomX: number) {
    this.x = randomX;
    this.y = 0;
    this.width = 30;
    this.height = 30;
    this.image = new Image();
    this.image.src = starImage;

    this.hitboxX = this.x;
    this.hitboxY = this.y;
    this.hitboxWidth = 30;
    this.hitboxHeight = 30;
  }

  down() {
    this.y += 6;
    this.hitboxY += 6;
  }

  draw(ctx: CanvasRenderingContext2D) {
    ctx.fillStyle = "red";
    // ctx.fillRect(
    //   this.hitboxX,
    //   this.hitboxY,
    //   this.hitboxWidth,
    //   this.hitboxHeight
    // );
    ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
  }
}
